<template>
    <div>
        <div class="mb-4">
            <div v-if="!is_editing">
                <update :update="update"></update>
            </div>

            <div v-else>
                <b-form @submit.prevent="onSubmit()">
                    <b-form-group>
                        
                        <label>
                            Title
                        </label>

                        <b-form-input
                            type="text"
                            v-model="form.title"
                            required>    
                        </b-form-input>
                        
                        <label>
                            Body
                        </label>

                        <b-form-textarea
                            v-model="form.body"
                            required>    
                        </b-form-textarea>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        Submit
                    </b-button>
                </b-form>
            </div>

            <div class="text-right">
                <a href="#" class="text-primary font-weight-bold mr-2" @click.prevent="toggleEdit">
                    {{ !is_editing ? "Edit" : "Cancel editing" }}
                </a>

                <a href="#" class="text-danger font-weight-bold" @click.prevent="askDeleteItem">
                    Delete
                </a>
            </div>
        </div>

        <b-modal 
            v-model="show_delete_modal"
            id="delete-modal"
            title="Warning"
            @ok="deleteItem()"
            header-bg-variant="danger"
            header-text-variant="light"
            ok-title="Delete"
            ok-variant="danger">
            Are you sure you want to permanently delete this update?
        </b-modal>
    </div>
</template>

<script>
    import Update from '@/components/Update.vue';

    export default {
        props: ['update'],

        components: {
            Update
        },
        
        data() {
            return {
                is_editing: false,
                show_delete_modal: false
            }
        },

        computed: {
            form() {
                return {
                    ...this.update
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('changed', { ...this.form });
                this.is_editing = false;
            },

            toggleEdit() {
                this.is_editing = !this.is_editing;
            },

            askDeleteItem() {
                this.show_delete_modal = true;
            },
            
            deleteItem() {
                this.$emit('deleted', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    form {
        margin-bottom: 10px;
    }

    .form-group {
        margin-bottom: 0;
    }

    .alert {
        margin-top: 5px;
    }

    textarea {
        margin-bottom: 10px;
    }
</style>